import { TokenStorageMethod } from './constants.js';

var DefaultTokenStorageMethod = TokenStorageMethod.LocalStorage;
var tokenStorageMethod = DefaultTokenStorageMethod;

var getTokenStorageMethod = function getTokenStorageMethod() {
  return tokenStorageMethod;
};

var setTokenStorageMethod = function setTokenStorageMethod(method) {
  tokenStorageMethod = method;
};

export { getTokenStorageMethod, setTokenStorageMethod };
